/**
 * Constants for Room Settings Modal
 */

// Page identifiers
export const ROOM_SETTINGS_PAGES = {
  SECURITY: 'security',
  PERMISSIONS: 'permissions',
  NOTIFICATIONS: 'notifications',
  DETAILS: 'details',
};

// Power level constants
export const POWER_LEVELS = {
  CUSTOM: -1, // Marker for custom input
  DEFAULT: 0,
  MODERATOR: 50,
  ADMIN: 100,
};

// Power level options for dropdowns (labels are i18n keys, resolve with t())
export const POWER_LEVEL_OPTIONS = [
  { value: POWER_LEVELS.DEFAULT, label: 'RoomSettings.powerLevelDefault' },
  { value: POWER_LEVELS.MODERATOR, label: 'RoomSettings.powerLevelModerator' },
  { value: POWER_LEVELS.ADMIN, label: 'RoomSettings.powerLevelAdmin' },
  { value: POWER_LEVELS.CUSTOM, label: 'RoomSettings.powerLevelCustom' },
];

// Join rule constants
export const JOIN_RULES = {
  INVITE: 'invite', // Only invited users can join
  PUBLIC: 'public',  // Anyone can join
};

// History visibility constants
export const HISTORY_VISIBILITY = {
  INVITED: 'invited',       // Visible from invitation
  JOINED: 'joined',         // Visible from joining
  SHARED: 'shared',         // Visible for all participants
  WORLD_READABLE: 'world_readable', // Visible for everyone
};

// Permission event types
// Note: Per Matrix spec, message events use events_default, not events['m.room.message']
// See: https://spec.matrix.org/v1.11/client-server-api/#mroompower_levels
export const PERMISSION_EVENTS = {
  DEFAULT: 'users_default',
  SEND_MESSAGE: 'events_default', // Controls m.room.message and other message events
  CONFIGURE: 'state_default',
  BAN: 'ban',
  KICK: 'kick',
  REDACT: 'redact',
  INVITE: 'invite',
  HISTORICAL: 'events.m.room.history_visibility',
};

// Labels for permission functions (values are i18n keys, resolve with t())
export const PERMISSION_LABELS = {
  [PERMISSION_EVENTS.DEFAULT]: 'RoomSettings.permDefault',
  [PERMISSION_EVENTS.SEND_MESSAGE]: 'RoomSettings.permSendMessages',
  [PERMISSION_EVENTS.CONFIGURE]: 'RoomSettings.permConfigureChat',
  [PERMISSION_EVENTS.BAN]: 'RoomSettings.permBanFromChat',
  [PERMISSION_EVENTS.KICK]: 'RoomSettings.permKickFromChat',
  [PERMISSION_EVENTS.REDACT]: 'RoomSettings.permDeleteMessage',
  [PERMISSION_EVENTS.INVITE]: 'RoomSettings.permInviteContact',
  [PERMISSION_EVENTS.HISTORICAL]: 'RoomSettings.permHistorical',
};

export const EXPORT_MESSAGE_LIMIT = 500;
